import React from 'react';
import partners from '../../data/partners.json';
import './LogoMarquee.css';

const LogoMarquee = () => {
  // Two identical groups so the track can translate exactly one group width
  // (-50%) for a perfectly seamless, infinite loop.
  return (
    <section className="marquee" aria-label="Trusted by the brands shaping gaming">
      <div className="tra-container">
        <p className="marquee__label">Trusted by the brands shaping gaming</p>
      </div>
      <div className="marquee__viewport" aria-hidden="true">
        <div className="marquee__track">
          {[0, 1].map((group) => (
            <div className="marquee__group" key={group}>
              {partners.map((p, i) => (
                <div className="marquee__item" key={`${group}-${i}`}>
                  <img src={process.env.PUBLIC_URL + p.logo} alt={p.name} loading="lazy" />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LogoMarquee;
